import { Text } from "grommet";
import styled from "styled-components";

const StyledText = styled(Text)`
  white-space: nowrap;
`;

export default StyledText;
